import React from 'react';
import { Checkbox as CheckboxIcon, CheckboxOutlineBlank, WarningFilled } from "../../icons";
import colors from "../../utils/colors";
import uniqid from 'uniqid';
import clsx from 'clsx';
import Guideline from "../Guideline";

import { createStyles } from "./styles";

var Checkbox = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var
    checked =











    props.checked,onChange = props.onChange,label = props.label,name = props.name,_props$id = props.id,id = _props$id === void 0 ? uniqid() : _props$id,highlightColor = props.highlightColor,_props$validationPass = props.validationPassed,validationPassed = _props$validationPass === void 0 ? true : _props$validationPass,validationMessage = props.validationMessage,_props$disabled = props.disabled,disabled = _props$disabled === void 0 ? false : _props$disabled,className = props.className,guidelines = props.guidelines,showGuidelinesByDefault = props.showGuidelinesByDefault;
  var classes = createStyles(props);
  return /*#__PURE__*/(
    React.createElement(React.Fragment, null, /*#__PURE__*/
    React.createElement("label", { className: classes.wrapper, htmlFor: id },
    checked ? /*#__PURE__*/
    React.createElement(CheckboxIcon, {
      width: "1.8rem",
      className: classes.icon,
      color:
      props.disabled === true ?
      colors.neutral[400] :
      highlightColor || (!validationPassed ? colors.red[500] : colors.neutral[900]) }) : /*#__PURE__*/



    React.createElement(CheckboxOutlineBlank, {
      width: "1.8rem",
      className: classes.icon,
      color:
      props.disabled === true ?
      colors.neutral[400] :
      highlightColor || (!validationPassed ? colors.red[500] : colors.neutral[900]) }), /*#__PURE__*/



    React.createElement("input", {
      type: "checkbox",
      onChange: onChange,
      checked: checked,
      className: clsx(classes.checkbox, className),
      ref: ref,
      id: id,
      name: name,
      disabled: disabled }), /*#__PURE__*/

    React.createElement("span", { className: classes.labelText }, label),
    !validationPassed && /*#__PURE__*/
    React.createElement("p", { className: classes.validationBlock }, /*#__PURE__*/
    React.createElement(WarningFilled, { color: colors.blue[600], width: "1.2rem", height: "1.2rem" }), /*#__PURE__*/
    React.createElement("span", { className: classes.validationMessage }, validationMessage))),



    guidelines && /*#__PURE__*/
    React.createElement(Guideline, {
      text: guidelines,
      showGuidelinesByDefault: showGuidelinesByDefault,
      className: classes.checkboxGuideline })));




});
Checkbox.displayName = 'Checkbox';
export default Checkbox;
//# sourceMappingURL=index.js.map